<script>
import { TabList, TabItem, TabContent } from './index.js';
import OrderFieldString from '../order-fields/order-field-string.vue';
import { mapActions, mapState } from 'pinia';
import { orderStore } from '../../../stores/order.js';
import FadeInOutTransition from '../transitions/FadeInOutTransition.vue';
import TabContentList from '@/components/order-vue/order/components/tabs/TabContentList.vue';

export default {
	components: {
		TabContentList,
		FadeInOutTransition,
		OrderFieldString,
		TabList,
		TabItem,
		TabContent
	}, 
	
	computed: {
		...mapState(orderStore, [
			'isInitialized', 
			'personTypes', 
			'userData', 
			'userAgreement', 
			'personalFields', 
			'currentPersonType'
		]),
		
		activePersonalFields() {
			return this.personalFields.filter((field) => field.type === 'STRING');
		},
		
		currentPerson() {
			return this.currentPersonType?.id;
		}
	},
	
	methods: {
		...mapActions(
			orderStore,
			{
				reloadOrderStorage: 'reloadOrderData',
				selectPersonType: 'changePersonType',
				setUserAgreementStatus: 'changeUserAgreementStatus',
			}
		),
		
		handleTabSelect(personType) {
			this.selectPersonType(personType);
		}
	}
};
</script>

<template>
	<TabList v-model:activeTab="currentPerson" container-class="checkout-item__tabs">
		<TabItem
			v-for="(personType) in personTypes"
			:key="personType.id"
			:value="personType.id"
			:active="currentPerson === personType.id"
			@select="handleTabSelect(personType)"
		>
			{{ personType.name }}
		</TabItem>
	</TabList>
	<TabContentList :class-list="[ 'checkout-item__tabs-body' ]">
		<FadeInOutTransition>
			<TabContent
				v-if="currentPerson"
				:key="currentPerson"
				:value="currentPerson"
				:active-tab="currentPerson"
			>
				<div v-if="activePersonalFields" class="checkout-item__form-group">
					<OrderFieldString
						v-for="field in activePersonalFields"
						:key="field.id"
						:field="field"
					/>
				</div>
			</TabContent>
		</FadeInOutTransition>
	</TabContentList>
</template>
